/* Prime Honey | sitewide header pill + nav sheet.
   Ported from Prime Organics' po-head. Two Prime Honey specifics on top of it:
   the bar it sits under is the phx2 countdown strip (which relocates itself above
   the header group), and the cart trigger is whatever this theme already wires to
   #cart-icon-bubble, so the anchor keeps that id and we never build a cart path. */
(function () {
  var d = document;

  function boot(head) {
    if (head.phBooted) return;
    head.phBooted = true;

    var burger = head.querySelector('[data-ph-menu]');
    var panel = d.getElementById(head.dataset.phPanel || 'ph-nav-panel');
    var cartBtn = head.querySelector('[data-ph-cart]');
    var countEl = head.querySelector('[data-ph-cart-count]');

    /* ---- scrolled state, and offset under any bar still on screen ----
       The phx2 timer moves its own section above the header group, so it is an
       in-flow bar sitting above us. Measure it rather than assume a height: it
       is 50px on phones and 59px on desktop, and it scrolls away. */
    var ticking = false;
    function topBar() {
      /* the inner .phx2t is the element that actually gets pinned; its section
         wrapper stays position:relative, so measuring the wrapper would report
         "not pinned" and hand the pill a shrinking offset it should not have */
      return d.querySelector('.phx2t') || d.querySelector('.phx2-timer-bar') || d.querySelector('[data-ph-annc]');
    }
    function paint() {
      head.classList.toggle('is-scrolled', window.scrollY > 8);
      var bar = topBar();
      var h = bar ? bar.offsetHeight : 0;
      /* A bar that is itself pinned never scrolls away, so the pill's offset is its
         full height at all times. Only an in-flow bar gets the shrinking offset. */
      var pinned = false;
      if (bar) {
        var pos = getComputedStyle(bar).position;
        pinned = (pos === 'sticky' || pos === '-webkit-sticky' || pos === 'fixed');
      }
      var top = pinned ? h : Math.max(0, h - window.scrollY);
      /* More than one strip can be pinned up there: the countdown, and the promo bar
         which reveals on scroll and fixes itself to the body. Sit under whichever
         reaches furthest down, or the pill lands on top of one of them. */
      d.querySelectorAll('.pcxpromo, [data-ph-pinned]').forEach(function (el) {
        if (getComputedStyle(el).position !== 'fixed') return;
        if (getComputedStyle(el).visibility === 'hidden') return;
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.bottom > top) top = Math.round(r.bottom);
      });
      head.style.setProperty('--phh-top', top + 'px');
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { paint(); measureSheet(); ticking = false; });
    }, { passive: true });
    window.addEventListener('resize', function () { paint(); measureSheet(); });
    paint();

    /* ---- how far down the sheet starts ----
       Read off the live pill rather than compute it from tokens: with the
       countdown strip on screen the pill sits lower than its own height says. */
    function measureSheet() {
      if (!panel) return;
      var ref = head.querySelector('.ph-head__pill');
      if (!ref) return;
      var b = ref.getBoundingClientRect().bottom;
      if (b > 0) panel.style.setProperty('--phh-sheet-top', Math.round(b) + 'px');
    }
    measureSheet();
    window.addEventListener('load', measureSheet);

    /* ---- the sheet ---- */
    if (burger && panel) {
      var items = panel.querySelectorAll('.ph-nav__link, .ph-nav__feature, .ph-nav__foot');
      for (var i = 0; i < items.length; i++) {
        items[i].style.setProperty('--phh-d', (0.06 + i * 0.045).toFixed(3) + 's');
      }

      var open = function () {
        measureSheet();
        panel.classList.add('is-open');
        burger.setAttribute('aria-expanded', 'true');
        d.body.classList.add('ph-nav-open');
        var sheet = panel.querySelector('.ph-nav__sheet');
        if (sheet) setTimeout(function () { sheet.focus(); }, 180);
      };
      var close = function (focusBack) {
        panel.classList.remove('is-open');
        burger.setAttribute('aria-expanded', 'false');
        d.body.classList.remove('ph-nav-open');
        if (focusBack) burger.focus();
      };

      burger.addEventListener('click', function () {
        panel.classList.contains('is-open') ? close(false) : open();
      });
      var scrim = panel.querySelector('[data-ph-close]');
      if (scrim) scrim.addEventListener('click', function () { close(false); });
      d.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && panel.classList.contains('is-open')) close(true);
      });
      panel.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' && e.keyCode !== 9) return;
        var f = panel.querySelectorAll('a[href], button:not([disabled])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      });
      /* a link navigates, so let the sheet shut behind it. An in-page anchor does
         not navigate at all, which would otherwise leave it hanging open. */
      panel.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('a[href]')) close(false);
      });
    }

    /* ---- cart count ---- */
    var last = null;
    function setCount(n) {
      if (!countEl) return;
      countEl.textContent = n;
      if (last !== null && n !== last && cartBtn) {
        cartBtn.classList.remove('is-bumped');
        void cartBtn.offsetWidth;
        cartBtn.classList.add('is-bumped');
      }
      last = n;
    }
    function refresh() {
      fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { setCount(c.item_count); })
        .catch(function () {});
    }
    refresh();
    d.addEventListener('cart-drawer:refresh', function () { setTimeout(refresh, 400); });
    d.addEventListener('cart:refresh', function () { setTimeout(refresh, 400); });
    d.addEventListener('kaching:cart-updated', function () { setTimeout(refresh, 400); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  }

  function run() {
    d.querySelectorAll('[data-ph-head]').forEach(function (el) {
      try { boot(el); } catch (e) { if (window.console) console.warn('ph-head:', e); }
    });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', run); else run();
  d.addEventListener('shopify:section:load', run);
})();
